import React from 'react';
import { Divider, Paper, styled } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { isUndefined } from 'lodash';

const StyledPaper = styled(Paper)(() => ({
  marginRight: '1em',
  padding: '1em',
  textAlign: 'center',
  minWidth: '200px',
}));

const StyledTitle = styled('small')(() => ({
  textTransform: 'uppercase',
  fontWeight: 700,
}));

const StyledSkeleton = styled(Skeleton)(() => ({
  width: '80%',
  margin: 'auto',
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  height: 2,
  width: '20%',
  margin: `${theme.spacing()} auto`,
}));

const StyledBody = styled('p')(({ theme }) => ({
  fontFamily: theme.typography.mainFont,
  fontSize: '1.125em',
}));

const StyledSkeletonBody = styled(Skeleton)(() => ({
  width: '50%',
  margin: 'auto',
}));

type InfoCardProps = {
  title: string;
  body: string;
};

const InfoCard = ({ title, body }: InfoCardProps) => (
  <StyledPaper>
    {title && !isUndefined(body) ? <StyledTitle>{title}</StyledTitle> : <StyledSkeleton variant="text" />}
    <StyledDivider />
    {!isUndefined(body) ? <StyledBody>{body ?? '-'}</StyledBody> : <StyledSkeletonBody variant="text" />}
  </StyledPaper>
);

export default InfoCard;
